import React from 'react'
import StiMain from '../components/sti-testing/StiMain'
import StiInfections from '../components/sti-testing/StiInfections'
import StiCauses from '../components/sti-testing/StiCauses'
import StiSymptoms from '../components/sti-testing/StiSymptoms'
import StiTestingService from '../components/sti-testing/StiTestingService'
import StiTestingChicago from '../components/sti-testing/StiTestingChicago'
import StiTestingNeeded from '../components/sti-testing/StiTestingNeeded'
import StiHivTesting from '../components/sti-testing/StiHivTesting'
import StiStdTesting from '../components/sti-testing/StiStdTesting'
import StiMap from '../components/sti-testing/StiMap'
import MainHeader from '../layout/MainHeader'
import TopHeader from '../layout/TopHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import MainResHeader from '../layout/MainResHeader'
import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const StiPage = () => {

  useEffect(()=>{
    window.scrollTo(0, 0)
  },[])

  return (
    <div style={{ overflow:'hidden'}}>
    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Confidential STI &amp; STD Testing in Chicago - Professional Services</title>
      <meta name="description" content="Ensure your privacy with our confidential STI testing in Chicago. Our professional and discreet services deliver accurate results." />
	<link rel="canonical" href="https://unitedlabcare.com/sti-and-std-testing-in-chicago/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Confidential STI &amp; STD Testing in Chicago - Professional Services" />
	<meta property="og:description" content="Ensure your privacy with our confidential STI testing in Chicago. Our professional and discreet services deliver accurate results." />
	<meta property="og:url" content="https://unitedlabcare.com/sti-and-std-testing-in-chicago/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-08-11T10:41:08+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2023/06/Bacteria-icon-ULC-STI-Testing.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="6 minutes" />
      </Helmet>
    </HelmetProvider>
        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
        
        <StiMain/>
        <StiInfections/>
        <StiCauses/>
        <StiSymptoms/>
        <StiTestingService/>
        <StiTestingChicago/>
        <StiTestingNeeded/>
        <StiHivTesting/>
        <StiStdTesting/>
        <StiMap/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default StiPage